module.exports = __webpack_public_path__ + "assets/img/title-e8401b9d.png";